import { Link, useLocation, type LinkProps } from 'react-router-dom'
import { languageFromPath, resolveLocalizedPath } from '@/i18n/routes'
import type { SupportedLanguage } from '@/i18n'

interface LocalizedLinkProps extends Omit<LinkProps, 'to'> {
  to: string
  language?: SupportedLanguage
}
export function LocalizedLink({ to, language, children, state, ...props }: LocalizedLinkProps) {
  const location = useLocation()
  const path = resolveLocalizedPath(to, language ?? languageFromPath(location.pathname))
  if (/^(https?:|mailto:|tel:)/.test(path)) return <a href={path} {...props}>{children}</a>
  const stateObject = state && typeof state === 'object' ? state : {}
  const shouldScrollToTop = !path.includes('#') && !stateObject.preserveScroll
  const navigationState = shouldScrollToTop ? { ...stateObject, smoothScrollTop: true } : state
  return <Link to={path} state={navigationState} {...props}>{children}</Link>
}
